export const setFilter = (filter) => ({
  type: 'SET_FILTER',
  payload: filter
});
